import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { DepartureReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

interface Props {
  defaultValues: DepartureReportFormModel;
  onSubmit: (data: DepartureReportFormModel) => void;
}

export const FilterFormProvider: FC<Props> = ({ defaultValues, onSubmit }) => {
  const form = useForm<DepartureReportFormModel>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={() => form.reset(defaultValues)} />
    </FormProvider>
  );
};
